export const UserModalTestIDs = {
  firstNameInput: "user-modal-first-name",
  lastNameInput: "user-modal-last-name",
  emailInput: "user-modal-email",
};
